import { Box, Container, HStack, Modal, ModalBody, ModalContent, ModalOverlay, Stack, useBreakpointValue, VStack, Text } from "@chakra-ui/react";
import React from "react";
import { explore } from "../../../../constants/constants";
import { CopyPasteService } from "../../../../services/CopyPaste";
import InfiniteScroll from "react-infinite-scroll-component";
import { FilterBox } from "../../../../CommonComponents/Filter/FilterBox";
import NoMoreToLoad from "../../../../CommonComponents/NoMoreToLoad";
import { DataNotFound } from "../../../../CommonComponents/DataNotFound";
import FilterPills from "../../../../CommonComponents/Filter/FilterPills";
import { cleanText } from "../../../../util/helper";

const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;
const loaderImg = `${IMAGE_BASE_PATH}/ui/Chevron/loader.gif`;

function TabularView({
  masterlistType = "generic",
  fetchMoreData,
  data,
  filterPills,
  setFilterPills,
  showFilterBox,
  handleFilterClick,
  hasMore,
  handleDrawer,
  setShowFilterBox,
  setApply,
  sort,
  handleCheckboxChange,
  handleSearch,
  filterOptions,
  filteroptionData,
  setFilterOptions,
  setSearchTerm,
  filterCount,
  searchTerm,
  handleReset,
  filterbuttonStyle,
  filteredResultCount,
}) {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <>
      <Stack mt={{base:"-40px!important",md:"0px!important"}} flexDirection={{base:"column",md:"row-reverse"}}>
        <Container
          maxW="auto"
          className="songs"
          px={{ base: "0px", md: "0px" }}
          py={{ base: "0", md: "30px" }}
          position={"relative"}
        >
          <Stack flexDirection={{base:"column",md:"row"}} gap={0} justifyContent="space-between">

            {data && data?.length > 0 ? (
             <Stack
             flexDirection={"column"}
             gap={0}
             height="100%"
             onCopy={(e) => CopyPasteService(e, `${window.location.href}/0/0`)}
             width={"100%"}
             marginRight={{ base: "0px", md: "30px" }}
           >
             <Box bg="white" zIndex={9} width={"100%"} position={"sticky"} top={masterlistType === "search" ? "0px" : "105px"}>
             {((filterPills &&  filterPills?.search) || filterCount > 0) && 
          <FilterPills
          filters={filterPills}
          setFilterOptions={setFilterOptions}
          setApply={setApply}
          setSearchTerm={setSearchTerm}
          setFilterPills={setFilterPills}
          filteredResultCount={filteredResultCount}
          />
          }</Box>
                <InfiniteScroll
                  dataLength={data?.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  loader={
                    <Box textAlign="center" display={"flex"} justifyContent={"center"}>
                      <Stack marginTop={"20px"}>
                        <img
                          src={loaderImg}
                          width={"100px"}
                          height={"100px"}
                          alt="Loading"
                        />
                      </Stack>
                    </Box>
                  }
                  endMessage={<NoMoreToLoad />}
                >
                  <Box>
                    <Stack spacing={4}>
                      {data.map((item, index) => (
                        <Box 
                          key={index} 
                          p={4} 
                          borderBottom="1px" 
                          borderColor="gray.200" 
                          onClick={() => handleDrawer(item)} 
                          cursor="pointer"
                          _hover={{ bg: "gray.50" }}
                          transition="all 0.2s"
                        >
                          <VStack align="flex-start" spacing={2}>
                            {/* {item.desc && (
                              <Text
                                fontSize={{ base: "14px", md: "16px" }}
                                fontWeight="600"
                                color="blue.500"
                                lineHeight="1.4"
                              >
                                {cleanText(item.desc)}
                              </Text>
                            )}
                            {!item.desc && (item.title || item.header) && (
                              <Text
                                fontSize={{ base: "14px", md: "16px" }}
                                fontWeight="600"
                                color="blue.500"
                                lineHeight="1.4"
                              >
                                {cleanText(item.title || item.header)}
                              </Text>
                            )}
                            {(item.author || item.fullname) && (
                              <Text fontSize="14px" color="gray.600" lineHeight="1.4">
                                {cleanText(item.author || item.fullname)}
                              </Text>
                            )}
                            {(item.publisher || item.publicationYear) && (
                              <Text fontSize="14px" color="gray.600" lineHeight="1.4">
                                {[item.publisher, item.publicationYear].filter(Boolean).join(', ')}
                              </Text>
                            )} */}
                            {item.listDesc && (
                              <Text
                                fontSize="14px"
                                color="gray.600"
                                lineHeight="1.4"
                                noOfLines={2}
                              >
                                {cleanText(item.listDesc)}
                              </Text>
                            )}
                          </VStack>
                        </Box>
                      ))}
                    </Stack>
                  </Box>
                </InfiniteScroll>
              </Stack>
            )
              : (
                <>
              <Stack
              onCopy={(e) =>
                CopyPasteService(e, `${window.location.href}/0/1`)
              }
              marginRight={{ base: "0px", md: "30px" }}
              alignItems={"flex-start"}
              width={"100%"}
            >
          <Box bg="white" width={"100%"} position={"sticky"} top={"105px"}>
          {((filterPills &&  filterPills?.search) || filterCount > 0) && 
                 <FilterPills
                 filters={filterPills}
                 setFilterOptions={setFilterOptions}
                 setApply={setApply}
                 setSearchTerm={setSearchTerm}
                 setFilterPills={setFilterPills}
                 filteredResultCount={filteredResultCount}
                 />
            }
            </Box>
                  <HStack width={"100%"} justifyContent={"center"}>
                   <DataNotFound />
  
                  </HStack>
                  </Stack>
              </>
              )}
            <HStack
              marginLeft={"4"}
              marginRight={"0px!important"}
              className="mt-0"
              alignItems={"flex-start"}
              pos={masterlistType === "generic" && "relative"}
              right={masterlistType === "generic" && "-5px"}
            >
              {showFilterBox && (
                isMobile ? (
                  <Modal isOpen={showFilterBox} onClose={() => setShowFilterBox(false)}     returnFocusOnClose={false}>
                    <ModalOverlay />
                    <ModalContent>
                      <ModalBody px="15px">
                        <FilterBox
                          setShowFilterBox={setShowFilterBox}
                          setApply={setApply}
                          explore={explore}
                          sort={sort}
                          handleCheckboxChange={handleCheckboxChange}
                          handleSearch={handleSearch}
                          filterOptions={filterOptions}
                          filteroptionData={filteroptionData}
                          setFilterOptions={setFilterOptions}
                          setSearchTerm={setSearchTerm}
                          filterCount={filterCount}
                          searchTerm={searchTerm}
                          handleReset={handleReset}
                          className="box-filter-film2"
                        />
                      </ModalBody>
                    </ModalContent>
                  </Modal>
                ):(
                <FilterBox
                  setShowFilterBox={setShowFilterBox}
                  setApply={setApply}
                  explore={explore}
                  sort={sort}
                  handleCheckboxChange={handleCheckboxChange}
                  handleSearch={handleSearch}
                  filterOptions={filterOptions}
                  filteroptionData={filteroptionData}
                  setFilterOptions={setFilterOptions}
                  setSearchTerm={setSearchTerm}
                  filterCount={filterCount}
                  searchTerm={searchTerm}
                  handleReset={handleReset}
                  className={masterlistType === "search" || masterlistType !== "research-categories" ? "box-filter-film" : "box-filter-film5"}
                />
                )
              )}
            </HStack>
          </Stack>
        </Container>
      </Stack>
    </>
  );
}
export default TabularView;

